// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/image/icon/iconfont.css'
import './assets/less/common.less'

import { Loading, Alert, Popconfirm } from 'element-ui'

import axios from 'axios'
import VueAxios from 'vue-axios' //异步请求

import VueWechatTitle from 'vue-wechat-title'

import moment from 'moment'

import Service from './service'

Vue.use(ElementUI)
Vue.component('el-input', {
  extends: ElementUI.Input,
  created() {
    this.$on('change', (value) => {
      this.$emit('input', value.trim())
    })
  }
})

Vue.use(VueAxios, axios)//全局使用 this.axios
Vue.use(VueWechatTitle)
Vue.use(Service)
Vue.config.productionTip = false
axios.defaults.withCredentials = true;//让axios携带cookie
axios.interceptors.request.use(
  config => {
    let _authToken = sessionStorage.getItem('AUTH_TOKEN')
    if (_authToken) {
      config.headers.authorizationToken = _authToken
    }
    return config
  }
)
Vue.prototype.$moment = moment

// 本地地址
// Vue.prototype.url = 'http://localhost:8082/'

//测试服务器
// Vue.prototype.url = 'http://139.196.41.186:8082/'  // 测试 node 8082
// Vue.prototype.furl = 'http://139.196.41.186:8083/'  // 测试 文件上传
// Vue.prototype.url = 'http://test.js-link.xyz/'  // 测试 

// 正式地址
Vue.prototype.url = 'http://api.js-link.xyz/' //node
Vue.prototype.furl = 'http://file.js-link.xyz/' //文件上传

/**
 * 路由跳转前刷新页面
 */
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.isRefresh)) {
    if (to.meta.isRefresh) {
      axios({
        method: 'Post',
        url: '/pages/common/refreshSession'
      }).then(res => {
        if (res.data.success) {
          console.log("refreshSession is succcess")
        } else {
          console.log("refreshSession is fail");
          alert(res.data.message + '请重新登录', '消息提示');
          next('/');
        }
      }).catch(err => {
        console.log("request is error")
        alert('请求出错，请重新登录', '消息提示')
        next('/');
      })
    } else {
      console.log("not refreshSession")
    }
    next();
  } else {
    console.log("next page")
    //若点击的是不需要刷新的页面,则进行正常的路由跳转
    next();
  }
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  Loading,
  Alert,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js